import { createElement, useEffect } from 'react';
import classNames from 'classnames';
import { mergeProps } from '../../utils/with-default-props';
import './index.scss';
const defaultProps = {
    visible: true,
    afterShow: () => { },
    afterClose: () => { },
    onMaskClick: () => { },
};
const ColorfulMask = function ColorfulMask(p) {
    const props = mergeProps(defaultProps, p);
    const { visible, maskClassName, afterShow, afterClose, onMaskClick, children } = props;
    const prefixCls = 'au-mask';
    useEffect(() => {
        if (visible) {
            afterShow();
        }
        if (!visible) {
            afterClose();
        }
    }, [visible]);
    if (!visible)
        return null;
    return (createElement("div", { ...props, className: classNames(prefixCls, maskClassName), onClick: onMaskClick }, children));
};
ColorfulMask.displayName = 'ColorfulMask';
export default ColorfulMask;
